// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3WbFv","empty":"ModalGraph_empty__10cmw"};